angular.module('content.widgets.defaultWidget', [
  'content.widgets.DefaultWidgetController'
])

/**
 * The componentDefaultWidget provides a preview
 * of the defaultWidget item type
 *
 * @class DefaultWidget
 * @constructor
 * @module content.widgets.defaultWidget
 * @example
 *   <default-widget
 *     model="form.model">
 *   </default-widget>
 */
.directive('defaultWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/defaultWidget/default-widget-edit.html';
        }
        return 'content/source/content/widgets/defaultWidget/default-widget.html';
      },
      controller: 'DefaultWidgetController'
    };
  }
]);
